// src/helpers/api.js
import axios from 'axios'
import supabase from '../supabaseClient'

// Define the BASE_URL as a separate constant
//const BASE_URL = 'http://localhost:3000/' // Update with your backend URL
const BASE_URL = 'https://houvalnodejs-94a2dd258952.herokuapp.com/' // Update with your backend URL

// Create an Axios instance with base configuration
const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to attach the Authorization header
apiClient.interceptors.request.use(async (config) => {
  const { data: { session }, error } = await supabase.auth.getSession()

  if (error || !session) {
    console.error('User not authenticated', error)
    throw new axios.Cancel('User not authenticated')
  }

  config.headers.Authorization = `Bearer ${session.access_token}`
  return config
}, (error) => {
  return Promise.reject(error)
})

/**
 * Makes an authenticated POST request to the specified endpoint with the given body.
 *
 * @param {string} endpoint - The API endpoint (relative to BASE_URL) to send the POST request to.
 * @param {object} body - The request payload.
 * @returns {Promise<any>} - The response data from the server.
 * @throws {Error} - Throws an error if the request fails.
 */
export const postRequest = async (endpoint, body) => {
  try {
    const response = await apiClient.post(endpoint, body)
    return response.data
  } catch (error) {
    if (axios.isCancel(error)) {
      console.warn('Request canceled:', error.message)
      throw new Error('Authentication required. Please log in again.')
    } else if (error.response) {
      // Server responded with a status other than 2xx
      console.error('Server Error:', error.response.data)
      throw new Error(error.response.data.error || 'Server Error')
    } else if (error.request) {
      // No response received
      console.error('Network Error:', error.request)
      throw new Error('Network Error. Please try again later.')
    } else {
      // Other errors
      console.error('Error:', error.message)
      throw new Error(error.message)
    }
  }
}


export const getRequest = async (url) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        // Add authentication headers if required
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
};